import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import FormDistributionResponse from '../responses/FormDistributionResponse'

const useFormDistribution = () => {
	const [data, setData] = useState<FormDistributionResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/form-distribution`)
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [])

	const total = (data?.physical ?? 0) + (data?.ebook ?? 0) + (data?.audio ?? 0)

	return [data, total, isLoading] as const
}

export default useFormDistribution
